/**
 * Utilities for calculating dashboard aggregates.
 */

/**
 * Calculates averages for a set of metrics from a data array.
 * Only includes rows where the metric is not null/undefined.
 * 
 * @param {Array} data Array of objects containing metrics
 * @param {Array} metrics List of metric keys to aggregate
 * @returns {Object} Object with aggregated averages for each metric
 */
export const calculateDashboardAggregates = (data, metrics) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return metrics.reduce((acc, metric) => {
      acc[metric] = 0;
      return acc;
    }, {});
  }

  return metrics.reduce((acc, metric) => {
    const validRows = data.filter((row) => row[metric] != null);
    
    if (validRows.length === 0) {
      acc[metric] = 0;
    } else {
      const sum = validRows.reduce((sumAcc, row) => sumAcc + row[metric], 0);
      acc[metric] = sum / validRows.length;
    }
    
    return acc;
  }, {});
};

/**
 * Default metrics used in CompanyDashboard.
 */
export const COMPANY_DASHBOARD_METRICS = [
  'CaloriesAVG',
  'CaloriesSUM',
  'DistanceAVG',
  'DistanceSUM',
  'HRVValueAvgAVG',
  'SleepHoursAVG',
  'SleepHoursAwakeAVG',
  'SleepHoursDeepAVG',
  'SleepHoursLightAVG',
  'StepsAVG',
  'StepsSUM',
  'StressAvgAVG',
];
